'use client';
import ReactPaginate from 'react-paginate';

import cn from '@/lib/clsxm';
import { useClientSmallScreen } from '@/lib/user-agent/client';

import Button from '@/components/@base/button';
import Container from '@/components/@base/container';
import Props from '@/components/shared/components/pagination-buttons/type';

import { DATA_CY_PAGE_NUMBER_NEXT } from '@/constant/cypress';
import localization from '@/constant/localization';

export default function PaginationButtons({
  totalPages = 0,
  currentPage = 1,
  onPageChange,
  pagePath,
  className,
}: Props) {
  const isSmallScreen = useClientSmallScreen();

  const handlePageClick = ({ selected }) => {
    onPageChange && onPageChange(selected + 1); // the +1 is because react-paginate index starts from 0;
  };

  const getPageUrl = (page: number) => {
    if (pagePath && page !== 0 && page !== totalPages + 1) {
      return `${pagePath}/${page}`;
    }
  };

  return (
    <Container center className={cn('my-8', className)}>
      <ReactPaginate
        forcePage={currentPage - 1} // Use forcePage to set the current page
        breakLabel='...'
        breakClassName='text-[#5B5C60]'
        nextLabel={
          <Button
            data-cy={DATA_CY_PAGE_NUMBER_NEXT}
            disabled={currentPage === totalPages}
            className='relative mr-2.5 bg-[#FFFFFF] px-6 py-2 text-[12px] font-medium text-[#8E8E8E] shadow-[0px_2px_8px_-2px_#B0B0B038]'
          >
            {localization.next}
            <Container className='absolute inset-0 flex h-full w-full items-center justify-center rounded-lg bg-[linear-gradient(247.65deg,_#FFC107_-35.57%,_#FF9737_100%)] font-medium text-[#FFFFFF] opacity-0 transition-all duration-300 hover:opacity-100'>
              {localization.next}
            </Container>
          </Button>
        }
        onPageChange={handlePageClick}
        pageRangeDisplayed={isSmallScreen ? 1 : 3}
        marginPagesDisplayed={isSmallScreen ? 1 : 2}
        pageCount={totalPages}
        previousLabel={
          <Button
            disabled={currentPage === 1}
            className='relative ml-2.5 bg-[#FFFFFF] px-5 py-2 text-[12px] font-medium text-[#8E8E8E] shadow-[0px_2px_8px_-2px_#B0B0B038]'
          >
            {localization.previous}
            <Container className='absolute inset-0 flex h-full w-full items-center justify-center rounded-lg bg-[linear-gradient(247.65deg,_#FFC107_-35.57%,_#FF9737_100%)] font-medium text-[#FFFFFF] opacity-0 transition-all duration-300 hover:opacity-100'>
              {localization.previous}
            </Container>
          </Button>
        }
        renderOnZeroPageCount={null}
        containerClassName='flex flex-wrap items-center justify-center bg-[#F9FAFC] p-1 gap-y-2 gap-x-[7px] rounded-md'
        pageClassName='text-[#5B5C60] cursor-pointer! w-9 h-9 text-[13px] font-medium rounded-[3px] flex items-center justify-center transition duration-300 hover:bg-[#878F9B] hover:text-white'
        activeClassName='bg-[linear-gradient(247.65deg,_#FFC107_-35.57%,_#FF9737_100%)] text-[#FFFFFF] font-bold!'
        pageLinkClassName='w-full text-center h-full leading-9'
        hrefBuilder={(pageIndex) => getPageUrl(pageIndex)}
        hrefAllControls
      />
    </Container>
  );
}
